import 'css-chunksrc/client/scenes/strategicAxisEdition/form/projectAdequacyInput/styles.scss';export default {
  "form": "_form_mpxey_1",
  "group": "_group_mpxey_20",
  "input": "_input_mpxey_24",
  "numberBox": "_numberBox_mpxey_35"
};